import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfiarDispositivoComponent } from './confiar-dispositivo.component';

@NgModule({
  declarations: [ConfiarDispositivoComponent],
  imports: [CommonModule],
  exports: [ConfiarDispositivoComponent]
})
export class ConfiarDispositivoModule { }
